export default __webpack_public_path__ + "static/media/new7.73f3707f.jpg";